import isVideoImage from './isVideoImage';

// The representative still for a product: its first non-video image. Video slots are reserved
// for the PDP gallery, so tiles, nav, and other previews use a real image instead.
// Returns `undefined` for an empty or all-video gallery (no still to show) — it never returns a
// video entry, which would 404 through CloudinaryPicture's image branch. Callers optional-chain.
const productCoverImage = product => (product?.images ?? []).find(image => !isVideoImage(image));

export default productCoverImage;
